// Redacts SAS `sig` values embedded in free text (e.g. PDF.js error messages quoting the signed URL).
export const redactSasSignaturesInText = (text: string): string =>
  text.replace(/([?&]sig=)[^&\s"')]+/gi, "$1<redacted>");

// Drops the SAS `sig` signature and collapses blob:/data: sources to their protocol
// so telemetry never carries signed credentials or inline document bytes.
export const sanitizeFileSrcForTelemetry = (fileSrc: string): string => {
  const lower = fileSrc.toLowerCase();
  if (lower.startsWith("blob:")) {
    return "blob:";
  }
  if (lower.startsWith("data:")) {
    return "data:";
  }

  try {
    const url = new URL(fileSrc, window.location.origin);

    Array.from(url.searchParams.keys())
      .filter((key) => key.toLowerCase() === "sig")
      .forEach((key) => url.searchParams.delete(key));

    return url.toString();
  } catch {
    return fileSrc.replace(/([?&])sig=[^&#]*(&?)/gi, (_, separator: string, trailingSeparator: string) =>
      separator === "?" ? (trailingSeparator ? "?" : "") : trailingSeparator
    );
  }
};
